import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { play } from 'cuelume'

type PaginationProps = {
  page: number
  limit: number
  total: number
  totalPages: number
  onPageChange: (page: number) => void
  onLimitChange: (limit: number) => void
}

const PAGE_SIZE_OPTIONS = [25, 50, 100] as const

export function Pagination({
  page,
  limit,
  total,
  totalPages,
  onPageChange,
  onLimitChange,
}: PaginationProps) {
  const hasResults = total > 0
  const canPrevious = page > 1
  const canNext = page < totalPages
  const displayPage = hasResults ? page : 0
  const displayTotalPages = hasResults ? totalPages : 0

  const handlePrevious = () => {
    if (!canPrevious) return
    play('page')
    onPageChange(page - 1)
  }

  const handleNext = () => {
    if (!canNext) return
    play('page')
    onPageChange(page + 1)
  }

  const handleLimitChange = (nextValue: string) => {
    const parsed = Number(nextValue)
    if (!Number.isFinite(parsed) || parsed <= 0) return
    if (parsed === limit) return
    onLimitChange(parsed)
  }

  return (
    <div className="flex flex-col gap-3 font-inter text-meta text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2">
        <span>{total} results</span>
        <span className="text-muted-foreground/60">•</span>
        <span>
          Page {displayPage} of {displayTotalPages}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <span>Rows</span>
          <Select value={String(limit)} onValueChange={handleLimitChange}>
            <SelectTrigger aria-label="Rows per page" className="h-8 w-[76px] border-border bg-white px-2 text-body text-foreground-secondary tabular-nums">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {PAGE_SIZE_OPTIONS.map((option) => (
                <SelectItem key={option} value={String(option)}>
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex items-center gap-2">
          <Button size="sm" variant="secondary"
  type="button"
  disabled={!canPrevious}
  onClick={handlePrevious}
  >
            Previous
          </Button>
          <Button size="sm" variant="secondary"
  type="button"
  disabled={!canNext}
  onClick={handleNext}
  >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
